{
  "cabin": {
    "mixed": "Kaikki matkustusluokat"
  }
}
